import React, { FunctionComponent } from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { openManageDataPeriodsModal } from "../../../../../store/onboarding/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faEdit } from "@fortawesome/free-solid-svg-icons";
import useUserRole from "../../../../../utils/hooks/useUserRole";

type DispatchProps = {
  openManageDataPeriodsModal: () => any;
};

type Props = DispatchProps;

const DataPeriodsPanel: FunctionComponent<Props> = ({
  openManageDataPeriodsModal,
}) => {
  const { isTeacher } = useUserRole();
  return (
    <>
      <span className="pointer" onClick={() => openManageDataPeriodsModal()}>
        <FontAwesomeIcon icon={isTeacher ? faBars : faEdit} />
      </span>
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      openManageDataPeriodsModal: openManageDataPeriodsModal,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(DataPeriodsPanel);
